import * as React from 'react';

/**
 * Delay a value using a timeout transition. The duration of the transition can be conditional to the value.
 */
export function useDelayedValue<T extends string>(
    value: T,
    delay: number | { [value in T]: number }
): T {
    const [delayedValue, setDelayedValue] = React.useState<T>(value);
    const timeoutDuration = typeof delay === 'number' ? delay : delay[value];

    React.useEffect(() => {
        if (!timeoutDuration) {
            return;
        }

        const timeout = setTimeout(() => {
            setDelayedValue(value);
        }, timeoutDuration);

        return () => {
            clearTimeout(timeout);
        };
    }, [value, timeoutDuration]);

    return timeoutDuration ? delayedValue : value;
}
